<template>
  <b-row>
    <b-col>
      <router-link to="/contracts" class="infobox-link">
        <Infobox :title="contracts.length"
                 :message="contractMessage"
                 :subtitle="$t('message.dashboard.infobox.contracts.subtitle')"
                 variant="dark">
          <span class="infobox-icon ti-receipt"></span>
        </Infobox>
      </router-link>
    </b-col>
    <b-col>
      <router-link to="/contactpersons" class="infobox-link">
        <Infobox :title="contactPersons.length"
                 :message="contactPersonsMessage"
                 :subtitle="$t('message.dashboard.infobox.contactPersons.subtitle')"
                 variant="dark">
          <span class="infobox-icon ti-user"></span>
        </Infobox>
      </router-link>
    </b-col>
    <b-col>
      <router-link to="/addresses" class="infobox-link">
        <Infobox
          :title="addresses.length"
          :subtitle="$t('message.dashboard.infobox.addresses.subtitle')"
          variant="dark">
          <span class="infobox-icon ti-home"></span>
        </Infobox>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
  import Infobox from '@/components/common/Infobox'

  export default {
    name: 'DashboardContent',
    components: {
      Infobox
    },
    computed: {
      addresses () {
        return this.$store.getters.addresses
      },
      contactPersons () {
        return this.$store.getters.contactPersons
      },
      contactPersonsMessage () {
        const invitations = this.$store.getters.invitations
        if (invitations.length !== 0) {
          return this.$t('message.dashboard.infobox.contactPersons.invitations', {amount: invitations.length})
        }
        return ''
      },
      contractMessage () {
        const incompleteContracts = this.contracts.filter(contract => !contract.isComplete)
        if (incompleteContracts.length > 0) {
          return this.$t('message.dashboard.infobox.contracts.completed', {amount: incompleteContracts.length})
        }
        return ''
      },
      contracts () {
        return this.$store.getters.contracts
      }
    },
    created () {
      this.$store.dispatch('fetchAddresses')
      this.$store.dispatch('fetchContactPersons')
      this.$store.dispatch('fetchContracts')
      this.$store.dispatch('fetchInvitations')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardContent.vue